import { ApiService } from "./api.service";
import type {
  TCurrentUserSessionPolicy,
  TWorkspaceSessionPolicy,
  TWorkspaceSessionPolicyUpdate,
} from "@/types/workspace";

export class WorkspaceSessionPolicyService extends ApiService {
  async getSessionPolicy(slug: string): Promise<TWorkspaceSessionPolicy> {
    return this.get(`/api/workspaces/${slug}/session-policy/`);
  }

  /** The CALLER's enforced thresholds — needs no permission beyond
   * authentication, unlike the admin-gated workspace config above (NG-1955). */
  async getEffectiveSessionPolicy(): Promise<TCurrentUserSessionPolicy> {
    return this.get("/api/users/me/session-policy/");
  }

  async updateSessionPolicy(
    slug: string,
    data: TWorkspaceSessionPolicyUpdate,
  ): Promise<TWorkspaceSessionPolicy> {
    return this.patch(`/api/workspaces/${slug}/session-policy/`, data);
  }
}
